// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"TrGridBody_cursorPointer__iH_GG","trHover":"TrGridBody_trHover__z7bd2"};